export function getInitialUrl(locationId: number | null, selectedTab?: string, entityId?: number): string {
	const segments: string[] = [];

	if (locationId != null) {
		segments.push(String(locationId));
	}

	if (selectedTab) {
		segments.push(selectedTab);
		if (entityId != null) {
			segments.push(String(entityId));
		}
	}

	return "/" + segments.join("/");
}

export function getInitialDialogSize(): { width: number; height: number } {
	if (typeof window === "undefined") return { width: 1600, height: 900 };

	const vw = window.innerWidth;
	const vh = window.innerHeight;

	return {
		width: Math.round(vw * 0.8),
		height: Math.round(vh * 0.8),
	};
}
